import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type BannerStripProps = CtaShellProps

export function BannerStrip(props: BannerStripProps) {
	return <CtaShell {...props} placement="inline" layout="strip" dismissible={props.dismissible ?? true} />
}